const getDefaultDriverState = () => {
  return {
    allDrivers: [],
  }
}

export default getDefaultDriverState()
export { getDefaultDriverState }
